<template>
  <div class="max-w-5xl mx-auto flex flex-wrap flex-col justify-between py-20">
    <div class="min-h-screen">
      <V2StoreHeader
        :store-name="store?.store_name"
        :attachments="inCart ? [] : store?.attachments || []"
        :banner-description="inCart ? '' : storeBannerDescription"
      >
        <V2BottleCycleBanner
          v-if="bottleStatusProps"
          v-bind="bottleStatusProps"
          @skip="$emit('bottle-cycle-skip')"
          @order-different-day="$emit('bottle-cycle-new')"
          @go-home="$emit('bottle-cycle-home')"
          @create-new-order="$emit('bottle-cycle-create-new')"
        />
      </V2StoreHeader>

      <div v-if="inCart" class="mt-4 mb-4 mx-4 md:mx-2">
        <h2 class="text-2xl font-bold text-gray-brand-900 tracking-tighter w-full">Your cart</h2>
        <SecondaryButton @click="$emit('showFullView')" class="mt-2" :size="'md'">
          <template #left-icon>
            <svg
              class="h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
            </svg>
          </template>
          Show all products
        </SecondaryButton>
      </div>

      <V2PackageSelection v-if="!inCart && hasPackages" :packages="store?.packages || []" />

      <!-- BOT-997: render unavailable items ABOVE the regular category grid
           to match V1 MerchantMain.vue (NoLongerAvailableCategory precedes
           the Category loop). -->
      <V2NoLongerAvailableCategory :items="unavailableCartItems" />

      <V2Category
        v-for="category in categories"
        :key="category.id"
        :category="category"
        :pricing-tiers="pricingTiers"
        :local-cart-items="localCartItems"
        :server-cart-items="serverCartItems"
        :offer-collapse-functionality="categories.length > 1"
        :in-cart="inCart"
      />

      <div
        v-if="inCart && cartIsEmpty"
        class="mx-4 md:mx-2 w-full bg-gray-brand-200 border border-gray-brand-400 rounded-lg px-4 py-2"
      >
        <h3 class="text-md text-gray-brand-700 w-full">There's nothing in your cart yet.</h3>
      </div>
    </div>
  </div>
</template>

<script>
import V2BottleCycleBanner from '@/components/v2/V2BottleCycleBanner'
import V2StoreHeader from '@/components/v2/V2StoreHeader'
import V2Category from '@/components/v2/V2Category'
import V2PackageSelection from '@/components/v2/V2PackageSelection'
import V2NoLongerAvailableCategory from '@/components/v2/V2NoLongerAvailableCategory'
import SecondaryButton from '@/components/Molecules/SecondaryButton.vue'

export default {
  name: 'V2Store',

  components: {
    V2BottleCycleBanner,
    V2StoreHeader,
    V2Category,
    V2PackageSelection,
    V2NoLongerAvailableCategory,
    SecondaryButton
  },

  emits: ['showFullView', 'bottle-cycle-skip', 'bottle-cycle-new', 'bottle-cycle-home', 'bottle-cycle-create-new'],

  props: {
    store: {
      type: Object,
      default: null
    },
    localCartItems: {
      type: Array,
      default: () => []
    },
    serverCartItems: {
      type: Array,
      default: () => []
    },
    inCart: {
      type: Boolean,
      default: false
    },
    bottleStatusProps: {
      type: Object,
      default: null
    },
    unavailableCartItems: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    categories() {
      return (this.store?.categories || []).filter((c) => c.type !== 'UpsellCategory')
    },
    pricingTiers() {
      return this.store?.pricing_tiers || []
    },
    hasPackages() {
      return (this.store?.packages || []).length > 0
    },
    storeBannerDescription() {
      return this.store?.banner_description || ''
    },
    cartIsEmpty() {
      return (this.localCartItems || []).length === 0
    }
  }
}
</script>
